export default __webpack_public_path__ + "components/app-store/static/s5-801ffed2e4cbf92363de0f6790814cc0.jpg";